import { render, staticRenderFns } from "./ImageCover.vue?vue&type=template&id=5251560c&scoped=true&"
import script from "./ImageCover.vue?vue&type=script&lang=ts&"
export * from "./ImageCover.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCover.vue?vue&type=style&index=0&id=5251560c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251560c",
  null
  
)

export default component.exports